/* ==========================================================================
   Listicle « L'Observatoire du Sommeil » — Cloudy v1
   Deux comportements :
     1. la barre d'achat fixe apparait apres 600 px de defilement (mobile) ;
     2. le jeton {date} est remplace par la date d'hier, recalculee a chaque
        visite. Ecrivez {date} dans n'importe quel bloc texte de la page pour
        l'afficher : « Mise a jour de la redaction du {date} ».
   ========================================================================== */
(function () {
  'use strict';

  /* --- 1. barre fixe ----------------------------------------------------- */
  var affichee = false;
  function surDefilement() {
    var v = window.scrollY > 600;
    if (v !== affichee) {
      affichee = v;
      document.body.classList.toggle('lo-scrolled', v);
    }
  }
  window.addEventListener('scroll', surDefilement, { passive: true });

  /* --- 2. date du jour moins un ------------------------------------------ */
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet',
              'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function hier() {
    var d = new Date();
    d.setDate(d.getDate() - 1);
    return d.getDate() + ' ' + MOIS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function remplacerDate(racine) {
    if (!racine) return;
    var texte = hier();
    var parcours = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, null);
    var noeud, cibles = [];
    while ((noeud = parcours.nextNode())) {
      if (noeud.nodeValue.indexOf('{date}') !== -1) cibles.push(noeud);
    }
    for (var i = 0; i < cibles.length; i++) {
      cibles[i].nodeValue = cibles[i].nodeValue.split('{date}').join(texte);
    }
  }

  function demarrer() {
    surDefilement();
    remplacerDate(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  // L'editeur de theme re-rend une section sans recharger la page.
  document.addEventListener('shopify:section:load', function (e) {
    remplacerDate(e.target);
  });
})();
